import React from "react";
import { useTheme } from "../../utils/ThemeContext";

const NotFoundTile = () => {
  const { theme } = useTheme();
  return (
    <div
      style={{
        width: "100%",
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}>
      <h3
        style={{
          color: theme === "light" ? "#232323" : "white",
        }}>
        No Tiles available please add from widgets.
      </h3>
    </div>
  );
};

export default NotFoundTile;
